import { render, staticRenderFns } from "./LeaveCalendar.vue?vue&type=template&id=a58b4134"
import script from "./LeaveCalendar.vue?vue&type=script&lang=js"
export * from "./LeaveCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports